<template>
<!-- chaper in monograph -->
    <div class="body-2 ma-0">
        <span v-if="chapter.book_title" 
          	v-html="chapter.book_title" 
			class="pa-0"></span><span 
				v-if="chapter.editors" 
					class="pa-0">, edited by: </span><span 
				v-if="chapter.editors" v-html="chapter.editors" class="pa-0"></span><span 
						v-if="chapter.serie_volume" class="pa-0">, <span 
						v-if="chapter.serie_volume" v-html="chapter.serie_volume" class="pa-0"></span></span><span 
							v-if="chapter.publisher" class="pa-0">, <span 
							v-if="chapter.publisher" v-html="chapter.publisher" class="pa-0"></span></span><span 
								v-if="chapter.address" class="pa-0">, <span v-if="chapter.address" v-html="chapter.address" class="pa-0"></span></span><span 
									v-if="year==2100" class="pa-0">, to appear</span><span 
									v-if="year < 2100" class="pa-0">, {{year}}</span><span 
										v-if="chapter.page_from" class="pa-0">, {{chapter.page_from}}</span><span 
										v-if="chapter.page_to" class="pa-0">-{{chapter.page_to}}.</span>
    </div>
</template>
<script>
export default {
  props:['chapter','year'],
}
</script>
.


